import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { I18n } from '@app/i18n/strings-keys';

@Component({
  selector: 'xea-global-loading-overlay',
  templateUrl: './global-loading-overlay.component.html',
  styleUrls: ['./global-loading-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GlobalLoadingOverlayComponent {
  @Input()
  public showLoader: boolean = true;

  @Input()
  public loading: string = I18n.CommonMessages.LoadingPleaseWait;

  public constructor() {}
}
